var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6786 100 100 77.6786 100 50C100 22.3214 77.6786 0 50 0C22.3214 0 0 22.3214 0 50C0 77.6786 22.3214 100 50 100Z",
    fill: "#0098EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1393 27.8574H32.8536C26.6036 27.8574 22.675 34.6431 25.7107 40.1788L46.7822 76.786C48.2107 79.1074 51.6036 79.1074 53.0322 76.786L74.1036 40.1788C77.3179 34.6431 73.3893 27.8574 67.1393 27.8574ZM46.9607 65.7146L42.3179 56.786L31.2464 36.9646C30.5322 35.7146 31.425 34.1074 33.0322 34.1074H46.9607V65.7146ZM68.7465 36.9646L57.675 56.786L53.0322 65.7146V34.1074H66.9607C68.5679 34.1074 69.4607 35.7146 68.7465 36.9646Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTon);
export default __webpack_public_path__ + "static/media/TON.c0b1aa8bafee2df7a110366c9b387c49.svg";
export { ForwardRef as ReactComponent };